export function setUserLogged(userLogged) {
  return {
    type: 'SET_USER_LOGGED',
    userLogged,
  }
}
